import { ProductCharacteristics } from "../modules";

export const ProductCharacteristicsPages = () => {
  return <ProductCharacteristics />;
};
